import { PropTypes } from 'prop-types';
import React from 'react';
import { classnames } from 'tailwindcss-classnames';

import { COLORS } from '../../constants/colors';
import Link from '../Link/Link';

const Logo = ({
  backgroundColor = COLORS.snow,
  className,
  foregroundColor = COLORS.liquorice,
  showShortLogo,
}) => (
  <svg
    className={classnames(
      className,
      'courier-logo',
      'text-[color:var(--courier-logo-foreground-color)]',
      'fill-current',
      'transition-color',
      'ease-in-out',
      'duration-300',
    )}
    fill="none"
    style={{
      '--courier-logo-background-color': backgroundColor,
      '--courier-logo-foreground-color': foregroundColor,
    }}
    viewBox={`75 0 ${showShortLogo ? 48 : 200} 48`}
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Bird */}
    <Link aria-label="Courier Home" to="/">
      <rect fill="none" height="48" pointerEvents="all" width="260" x="75" />
    </Link>
    <path
      d="M102.575 14.3208C102.378 14.3208 102.219 14.481 102.219 14.678C102.219 14.8732 102.378 15.0333 102.575 15.0333C102.771 15.0333 102.932 14.8732 102.932 14.678C102.932 14.481 102.771 14.3208 102.575 14.3208Z"
      fill="currentColor"
      id="bird-eye"
      pointerEvents="none"
    />
    <path
      d="M96.9651 2.27734C84.5875 2.27734 74.5527 12.277 74.5527 24.6132C74.5527 36.9475 84.5875 46.9472 96.9651 46.9472C109.345 46.9472 119.378 36.9475 119.378 24.6132C119.379 12.277 109.345 2.27734 96.9651 2.27734ZM105.673 15.825C105.609 15.8563 105.527 15.8103 105.455 15.8177C102.469 16.1178 104.894 20.2053 104.894 20.2053C105.675 21.8882 105.804 22.5418 105.777 23.827C105.708 26.9939 103.482 29.7318 100.897 31.2158C100.895 31.2121 100.895 31.2084 100.897 31.2176C100.897 31.2176 99.2969 33.0717 99.4041 33.8764L99.8808 34.9277H101.453C101.823 34.9277 102.122 35.1928 102.122 35.5224H101.453H100.029H99.138H98.4692H97.8021C97.8021 35.1928 98.1015 34.9277 98.4692 34.9277H98.8128C98.8128 34.9277 97.3365 34.2464 97.0501 32.3794C92.758 33.672 89.0959 31.7203 89.0959 31.7203C89.0959 31.7203 82.3629 34.0936 81.4261 33.3811C81.9158 32.9134 85.698 31.0206 86.3465 30.6487C97.78 24.1547 98.726 21.8955 98.726 21.8955C100.082 20.1261 99.7699 18.1321 100.127 16.2191C100.127 16.2191 100.357 14.967 100.361 14.9523C100.592 13.8733 101.522 13.1258 102.639 13.2216C103.473 13.2934 104.156 13.8255 104.467 14.5472C104.467 14.5472 104.18 14.8161 104.489 14.956C104.766 15.0812 104.871 14.7442 104.871 14.7442C105.474 14.8768 105.926 15.2285 106.019 15.6336C105.993 15.6888 105.74 15.7956 105.673 15.825Z"
      fill="currentColor"
      id="bird"
      pointerEvents="none"
    />
    {/* Courier */}
    {!showShortLogo && (
      <g>
        <path
          d="M174.59 29.9269C172.113 39.9228 163.353 46.5512 153.039 46.5512C139.669 46.5512 130.566 35.9826 130.566 24.556C130.566 13.7591 138.98 2.67865 152.924 2.67865C166.294 2.67865 173.439 12.9029 174.592 19.5295H163.181C161.971 16.3884 158.745 12.1591 152.867 12.1591C145.549 12.1591 141.458 18.5003 141.458 24.4989C141.458 30.899 145.837 37.0671 152.924 37.0671C159.724 37.0671 162.492 31.4109 163.181 29.9269H174.59Z"
          fill="currentColor"
          id="C"
          pointerEvents="none"
        />
        <path
          d="M192.898 13.0758C204.485 13.0758 210.048 22.1493 210.048 29.9101C210.048 37.6708 204.485 46.7462 192.898 46.7462C181.311 46.7462 175.748 37.6727 175.748 29.9101C175.748 22.1493 181.311 13.0758 192.898 13.0758ZM192.898 37.8991C197.028 37.8991 200.525 34.5334 200.525 29.9082C200.525 25.2868 197.026 21.9192 192.898 21.9192C188.768 21.9192 185.271 25.2849 185.271 29.9082C185.269 34.5334 188.768 37.8991 192.898 37.8991Z"
          fill="currentColor"
          id="o"
          pointerEvents="none"
        />
        <path
          d="M241.086 45.9138H232.051L232.119 42.1393H232.003C230.046 46.1845 226.135 46.5251 223.718 46.5251C221.761 46.5251 217.159 46.0703 214.337 42.537C211.806 39.4033 211.462 37.1239 211.462 32.7933V13.8784H221.013V31.37C221.013 33.5353 221.013 37.6965 226.135 37.6965C228.897 37.6965 231.602 36.2714 231.602 31.2577V13.8784H241.153L241.086 45.9138Z"
          fill="currentColor"
          id="u"
          pointerEvents="none"
        />
        <path
          d="M276.115 13.8561H266.497V45.9154H276.115V13.8561Z"
          fill="currentColor"
          id="i"
          pointerEvents="none"
        />
        <path
          d="M271.242 0C274.405 0 276.936 2.57955 276.936 5.74093C276.936 8.9023 274.405 11.4819 271.242 11.4819C268.204 11.4819 265.675 8.9023 265.675 5.74093C265.675 2.57955 268.206 0 271.242 0Z"
          fill="currentColor"
          id="i-dot"
          pointerEvents="none"
        />
        <path
          d="M322.677 45.9203H312.45V13.8536H322.677V45.9203ZM329.338 13.2717C333.105 13.2717 335.999 16.0465 335.999 19.6608C335.999 23.2107 333.105 25.9835 329.338 25.9835C325.637 25.9835 322.744 23.2088 322.744 19.6608C322.744 16.0465 325.637 13.2717 329.338 13.2717Z"
          fill="currentColor"
          id="r2"
          pointerEvents="none"
        />
        <path
          d="M310.185 35.9145C308.624 39.4939 306.368 42.2649 303.648 44.1135C300.985 46.0191 297.803 47.0005 294.505 47.0005C285.306 47.0005 277.496 39.5528 277.496 30.0281C277.496 21.078 284.554 12.8219 294.332 12.8219C304.11 12.8219 311.284 20.5588 311.284 30.3154C311.284 31.5877 311.168 32.1069 311.053 32.8563H286.983C287.564 36.6676 290.745 38.9176 294.505 38.9176C297.458 38.9176 299.019 37.59 300.348 35.9164H310.185V35.9145ZM301.68 26.3881C301.275 24.4824 299.367 20.9031 294.391 20.9031C289.415 20.9031 287.506 24.4824 287.1 26.3881H301.68Z"
          fill="currentColor"
          id="e"
          pointerEvents="none"
        />
        <path
          d="M252.463 45.9203H243.041V13.8536H252.463V45.9203ZM258.758 13.2717C262.318 13.2717 265.053 16.0465 265.053 19.6589C265.053 23.207 262.318 25.9835 258.758 25.9835C255.26 25.9835 252.525 23.2088 252.525 19.6589C252.525 16.0465 255.26 13.2717 258.758 13.2717Z"
          fill="currentColor"
          id="r"
          pointerEvents="none"
        />
      </g>
    )}
  </svg>
);

Logo.propTypes = {
  backgroundColor: PropTypes.string,
  className: PropTypes.string,
  foregroundColor: PropTypes.string,
  showShortLogo: PropTypes.bool,
};

export default Logo;
